<template>
    <v-row justify="center">
        <v-dialog v-model="showDialog" persistent max-width="600">
            <v-card>
                <v-card-title class="headline pt-1 pr-1 custom-card-header">
                    Import File
                    <v-spacer></v-spacer>
                    <v-btn icon @click="toggle" dark><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <br />
                <v-file-input show-size counter class="ma-2" label="Upload File" v-model="file"></v-file-input>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="primary" :disabled="btnDisabled" @click="fileUpload">Upload</v-btn>
                    <v-btn color="primary" outlined class="ma-2" @click="toggle">Cancel</v-btn>
                </v-card-actions>
                <div v-if="disabled" class="text-center">
                    Saving<br />
                    <v-progress-circular
                        indeterminate
                        color="success"
                        v-if="disabled"
                    ></v-progress-circular>
                </div>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import { mapActions} from 'vuex'
    export default {
        name: 'import-file-dialog',
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            }
        },
        data () {
            return {
                file: null,
                disabled: false,
                btnDisabled: true,
            }
        },
        watch: {
            file(newVal) {
                this.getNumberAndAddress()
                this.btnDisabled = !(newVal || newVal !== undefined);
            }
        },
        methods: {
            ...mapActions({
                stage: 'imports/stageFile',
                getNumberAndAddress: 'jobTasks/getNumberAndAddress'
            }),

            async fileUpload () {
                this.disabled = true
                await this.stage(this.file)
                await this.$router.push('/file/preview')
                this.disabled = false
            },
        },
    }
</script>
<style>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
</style>
